import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { FeatureFlagsService, FeatureFlags } from '../services/feature-flags.service';

/**
 * featureFlagGuard
 * Factory guard that blocks navigation when a feature flag is disabled.
 *
 * @param flagKey  - key of the feature flag to check
 * @param redirectTo - route to redirect when feature is disabled (default: '/maintenance')
 *
 * Usage in routes:
 * { path: 'merchant-onboarding', ..., canActivate: [featureFlagGuard('merchantOnboarding')] }
 */
export function featureFlagGuard(
  flagKey: keyof Omit<FeatureFlags, 'updatedAt' | 'updatedBy'>,
  redirectTo = '/maintenance'
): CanActivateFn {
  return () => {
    const featureFlagsService = inject(FeatureFlagsService);
    const router = inject(Router);

    return featureFlagsService.flag$(flagKey).pipe(
      take(1),
      map((enabled) => {
        if (enabled) {
          return true;
        }
        return router.createUrlTree([redirectTo]);
      })
    );
  };
}
